var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEmailInfo = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 36,
  height: 36,
  xmlns: "http://www.w3.org/2000/svg"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  fill: "#f2f2f2",
  height: 38,
  width: 38,
  y: -1,
  x: -1
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "null",
  strokeWidth: 0,
  id: "svg_1",
  fill: "#494949",
  d: "m27.090666,9.940343c0.557896,0 1.010074,0.451054 1.010074,1.007457l0,14.1044c0,0.55643 -0.452178,1.007457 -1.010074,1.007457l-18.181331,0c-0.557849,0 -1.010074,-0.451027 -1.010074,-1.007457l0,-14.1044c0,-0.556403 0.452225,-1.007457 1.010074,-1.007457l18.181331,0zm-1.010074,3.272221l-7.474547,5.593402c-0.359136,0.268659 -0.852952,0.268659 -1.212089,0l-7.474547,-5.592397l0,10.831175l16.161183,0l0,-10.832179zm-1.685829,-1.257307l-12.790551,0l6.395788,4.785427l6.394762,-4.785427z"
})));
export { SvgEmailInfo as ReactComponent };
export default __webpack_public_path__ + "assets/c8ff310c.svg";